import { Button, Typography, Avatar, Table } from "antd";
import Main from "../../components/layout/Main";
import TableImage from "../../assets/images/tabel-image.svg";
import CandidateImage from "../../assets/images/candidate-image.png";
import { useNavigate } from "react-router";
import LiveStreamCarousel from "../../components/forsliders";
import { useEffect, useState } from "react";
import { useForums } from "../../context/ForumsContext";
import { useGlobalSearch } from "../../context/GlobalSearchContext";
import { forumsAPI } from "../../services/api";

const columns = [
  {
    title: "Final Round",
    dataIndex: "title",
    key: "title",
    width: 400,
    render: (text, record) => (
      <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
        <img
          src={TableImage} // static icon (your API has no image)
          alt={text}
          style={{ width: 40, height: 40, borderRadius: 4, objectFit: "cover" }}
        />
        <span>{text}</span>
      </div>
    ),
  },
  {
    title: "No. of Subjects",
    dataIndex: "totalThread",
    key: "totalThread",
    width: 200,
  },
  {
    title: "No. of Comments",
    dataIndex: "totalComments",
    key: "totalComments",
    width: 200,
  },
  {
    title: "Last Participation",
    dataIndex: "lastParticipation",
    key: "lastParticipation",
    width: 400,
    render: (user) =>
      user ? (
        <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <img
            src={user.profilePic || CandidateImage}
            alt={user.name}
            style={{
              width: 40,
              height: 40,
              borderRadius: "50%",
              objectFit: "cover",
            }}
          />
          <div className="participation-class">
            <h4>{user.name}</h4>
            <h6>{user.timeAgo}</h6>
          </div>
        </span>
      ) : (
        <span>-</span>
      ),
  },
];

const ForumnsIndex = () => {
  const [forumsData, setForumsData] = useState([]);
  const { globalSearch } = useGlobalSearch();
  const { getForums, getForumById } = useForums();
  const [params, setParams] = useState({});
  const navigate = useNavigate();

  const fetchForums = async () => {
    try {
      const response = await getForums(params);
      if (response.success && response.data?.data) {
        const mapped = response.data.data.map((forum) => ({
          key: forum._id,
          ...forum,
        }));
        setForumsData(mapped);
      }
    } catch (error) {
      console.error(error, "---error fetching forums-->");
    }
  };

  const handleRowClick = async (forum) => {
    try {
      await getForumById(forum._id);
      navigate(`/forums/${forum._id}`);
    } catch (error) {
      console.error("Error fetching forum details:", error);
    }
  };

  // --------- Use Effects ------------
  useEffect(() => {
    setParams((prev) => {
      return {
        ...prev,
        search: globalSearch,
      };
    });
  }, [globalSearch]);

  useEffect(() => {
    fetchForums();
  }, [params]);

  return (
    <Main>
      <div className="section-main">
        <LiveStreamCarousel />
        <div className="new-main-table-clas">
          <div className="forum-section" style={{ marginBottom: "40px" }}>
            {/* <h3 style={{ color: "#fff", marginBottom: 16 }}>Open Forums</h3> */}
            <div className="table-responsive">
              <Table
                columns={columns}
                dataSource={forumsData}
                pagination={false}
                bordered={false}
                rowClassName={() => "custom-row"}
                onRow={(record) => ({
                  onClick: () => handleRowClick(record),
                })}
                scroll={{ x: "auto" }}
              />
            </div>
          </div>
        </div>
      </div>
    </Main>
  );
};

export default ForumnsIndex;
